import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Input } from 'reactstrap';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import FetchCMProductDataService from '../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';

function ViewProjectAsinList(props) {
  const {
    projectData,
    asinList,
    token
  } = props;

  const [productDetailsList, setProductDetailsList] = useState([]);
  const [searchText, setSearchText] = useState('');

  // Fetch product details when component mounts or props change
  useEffect(() => {
    if (projectData) {
      fetchProductDetails();
    }
  }, [projectData, asinList]);

  const fetchProductDetails = () => {
    // If asinList is null OR empty → show blank table
    if (!asinList || asinList.length === 0) {
      setProductDetailsList([]);
      return;
    }
  
    const data = {
      asinList: asinList.join(','),   // send only project ASINs
      integerID: projectData.integerId || projectData.storeId,
      projectId:0,
    };
  
    FetchCMProductDataService(token, data)
      .then((res) => {
        if (res && res.productsList) {
          setProductDetailsList(res.productsList); 
        } else {
          setProductDetailsList([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching product details:', error);
        setProductDetailsList([]);
      });
  };
  

  const columns = [
    {
      Header: "Parent Asin",
      accessor: "parentProduct",
      width: 110,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "ASIN",
      accessor: "asin",
      width: 110,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Product Title",
      accessor: "productTitle",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p 
            title={cellInfo.value}
            className='mb-0 comment-paragraph-Project-product-title'
          >
            {cellInfo.value}
          </p>
        </div>
      ),
    },
  ];

  const filterProductData = productDetailsList && productDetailsList.filter((row) => {
    const parentProduct = (row.parentProduct || row.parentAsin || row.parent_asin || '').toLowerCase();
    const productTitle = (row.productTitle || row.title || row.name || '').toString().toLowerCase();
    const asin = (row.asin || '').toString().toLowerCase();
    return (
      parentProduct.includes(searchText.toLowerCase()) ||
      asin.includes(searchText.toLowerCase()) ||
      productTitle.includes(searchText.toLowerCase())
    );
  });

  return (
    <>
      <Card className='curve-popup p-3'>
        <Row>
          <Col md={6}>
            <Input
              className="mb-2 w-100"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search ASIN by Title"
            />
          </Col>
          <Col md={12}>
            <ReactTable
              data={filterProductData}
              columns={columns}
              className="-fixed -highlight -striped mt-2"
              getTheadProps={() => ({
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              })}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                  return {
                    style: {
                      backgroundColor: '#dfd7ff', 
                    },
                  };
                }
                return {};
              }}
              defaultPageSize={5}
              noDataText={"Loading ASIN List..."}
            />
          </Col>
        </Row>
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
  };
};

export default connect(mapStateToProps)(ViewProjectAsinList);